const language = 'vietnamese';
export const langDir = 'ltr';

export default language;
